import { queryOptions, useMutation } from "@tanstack/react-query";
import {
    fetchCustomerPolygon,
    fetchParcel,
    putCustomerPolygon,
} from "./customer-service";

import { queryClient } from "src/lib/react-query";

export function customerPolgyonQueryOptions({
    customerCode,
}: {
    customerCode: string;
}) {
    return queryOptions({
        queryKey: ["customers", customerCode, "polygon"],
        queryFn: () => fetchCustomerPolygon({ customerCode }),
    });
}

export function useUpdateCustomerPolygon({
    customerCode,
}: {
    customerCode: string;
}) {
    return useMutation({
        mutationKey: ["customers", customerCode, "polygon"],
        mutationFn: putCustomerPolygon,
        onSuccess: () => queryClient.invalidateQueries(),
    });
}

export function parcelQueryOptions({
    latitude,
    longitude,
    address,
}: {
    latitude?: number;
    longitude?: number;
    address?: string;
}) {
    return queryOptions({
        queryKey: ["parcel"],
        queryFn: () => fetchParcel({ latitude, longitude, address }),
    });
}
